
export interface IFtpData {
    dst_paths:string
    export:string
    sync_paths:string[]
}


export const getDefaultFtpData = ():IFtpData => {
    return {        
        dst_paths:'',
        export:'ftp',
        sync_paths:[]
    }
} 